import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '@welldev-group/rcl-icon';
import { Text } from '@welldev-group/rcl-typography';
import { I18nText, Spinner } from '@welldev-group/react-comp-lib';

import { fetchFareBasisInfo } from '../../../actions/flight';

import FareBasisInfo from './FareBasisInfo';

const filterFareBasisInfo = (fareBasisInfo, filterSegments) => {
  if (!filterSegments) {
    return fareBasisInfo;
  }

  const filteredFareBasisInfo = [];

  fareBasisInfo.forEach(fareBasis => {
    const eligibleSegments = fareBasis.segments.filter(
      segment =>
        filterSegments.indexOf(`${segment.marketingCarrierCode}${segment.marketingFlightNumber}`) >=
        0,
    );
    if (eligibleSegments.length) {
      filteredFareBasisInfo.push({ ...fareBasis, segments: eligibleSegments });
    }
  });

  return filteredFareBasisInfo;
};

class FareBasisInfoList extends React.Component {
  componentDidMount() {
    this.props.fetchFareBasisInfo(this.props.id);
  }
  render() {
    if (!this.props.fareBasisInfo) {
      return (
        <div className="col-grid col-bleed-x align-center">
          <Spinner size="huge" bgColor="neutral" />
          <I18nText id="ibe.fare_basis_info.loading.text" />
        </div>
      );
    }
    if (this.props.fareBasisInfo.length <= 0) {
      return (
        <div className="col-grid col-bleed">
          <div className="col-12 col-grid col-bleed-x align-center flight__fare-rules-modal--no-fare-rules-icon">
            <Icon name="highPriority" size="huge" color="tertiary" showBGColor={true} />
          </div>
          <div className="col-12 col-grid col-bleed align-center">
            <Text level={1} weight="medium">
              {I18n.t('components.ibe.fare_basis_info.failed.header')}
            </Text>
            <Text level={2} weight="normal">
              {I18n.t('components.ibe.fare_basis_info.failed.subheader')}
            </Text>
          </div>
        </div>
      );
    }
    return (
      <Fragment>
        {filterFareBasisInfo(this.props.fareBasisInfo, this.props.filterSegments).map(
          fareBasisInfo => (
            <FareBasisInfo key={fareBasisInfo.info.code} {...fareBasisInfo} />
          ),
        )}
      </Fragment>
    );
  }
}

FareBasisInfoList.defaultProps = {
  fareBasisInfo: null,
  filterSegments: null,
  orderItemId: null,
};

FareBasisInfoList.propTypes = {
  id: PropTypes.string.isRequired,
  orderItemId: PropTypes.string,
  fareBasisInfo: PropTypes.shape([]),
  fetchFareBasisInfo: PropTypes.func.isRequired,
  filterSegments: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = (state, props) => ({
  fareBasisInfo: state.flights.fareBasisInfoByResultId[props.id],
});

const mapDispatchToProps = (dispatch, props) => ({
  fetchFareBasisInfo: () => dispatch(fetchFareBasisInfo(props.id, props.orderItemId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FareBasisInfoList);
